import {
  Card,
  CardContent,
  Chip,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableContainer,
  Typography,
} from "@mui/material";

interface LowStockTableProps {
  data: Array<{
    stockId: string;
    code: string;
    name: string;
    warehouseId: string;
    warehouseName?: string;
    availableQuantity: number;
  }>;
}

const LowStockTable = ({ data }: LowStockTableProps) => {
  const rows = data.slice(0, 6);

  return (
    <Card
      elevation={0}
      sx={(theme) => ({
        borderRadius: 3,
        border: "1px solid",
        borderColor: theme.palette.mode === "dark" ? "#2a3953" : "divider",
        bgcolor: theme.palette.mode === "dark" ? "#111b2d" : "background.paper",
        height: "100%",
        minWidth: 0,
        maxWidth: "100%",
        overflow: "hidden",
      })}
    >
      <CardContent sx={{ minWidth: 0 }}>
        <Typography
          variant="h6"
          fontWeight={700}
          mb={2}
        >
          Stock Attention
        </Typography>

        <TableContainer sx={{ width: "100%", maxWidth: "100%", overflowX: "auto" }}>
        <Table size="small" sx={{ minWidth: 620 }}>
          <TableHead>
            <TableRow>
              <TableCell>Part</TableCell>
              <TableCell>Code</TableCell>
              <TableCell>Hub</TableCell>
              <TableCell align="center">Available</TableCell>
              <TableCell align="center">Status</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {rows.length === 0 && (
              <TableRow>
                <TableCell colSpan={5}>
                  <Typography color="text.secondary">
                    No stock attention items available.
                  </Typography>
                </TableCell>
              </TableRow>
            )}

            {rows.map((row) => (
              <TableRow key={row.stockId} hover>
                <TableCell>{row.name}</TableCell>
                <TableCell>{row.code}</TableCell>
                <TableCell>{row.warehouseName || row.warehouseId}</TableCell>
                <TableCell align="center">
                  {row.availableQuantity}
                </TableCell>
                <TableCell align="center">
                  <Chip
                    label="Dead Stock"
                    color="warning"
                    size="small"
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        </TableContainer>
      </CardContent>
    </Card>
  );
};

export default LowStockTable;
